import apiClient from './api';

// Restaurant groups: the franchise / brand layer between the company and its
// branches. Company -> Restaurant Group -> Location.
const base = (restaurantId, id) =>
  `/users/restaurant/${restaurantId}/restaurant-groups/${id ? `${id}/` : ''}`;

export const restaurantGroupsService = {
  /** Every group with its branches, plus the branches that sit in no group. */
  list: async (restaurantId, { includeInactive = false } = {}) => {
    const { data } = await apiClient.get(base(restaurantId), {
      params: includeInactive ? { include_inactive: 'true' } : {},
    });
    return {
      groups: data?.results || [],
      ungrouped: data?.ungrouped_locations || [],
    };
  },
  get: async (restaurantId, id) => {
    const { data } = await apiClient.get(base(restaurantId, id));
    return data?.data;
  },
  create: async (restaurantId, payload) => {
    const { data } = await apiClient.post(base(restaurantId), payload);
    return data?.data;
  },
  update: async (restaurantId, id, payload) => {
    const { data } = await apiClient.put(base(restaurantId, id), payload);
    return data?.data;
  },
  remove: async (restaurantId, id) => {
    const { data } = await apiClient.delete(base(restaurantId, id));
    return data;
  },
  /** Replace the set of branches in a group. Listed branches move in; the group's others move out (to no group). */
  setLocations: async (restaurantId, id, locationIds) => {
    const { data } = await apiClient.put(`${base(restaurantId, id)}locations/`, { location_ids: locationIds });
    return {
      group: data?.data,
      ungrouped: data?.ungrouped_locations || [],
    };
  },
};
